import React from 'react';
// import loadingImg from '../images/loading 180px yellow.svg';

const Loading = () => (
   // <div className='spinner'>
   //    <img src={loadingImg} alt='Loading...' />
   // </div>
   <div className='lds-dual-ring hide'></div>
);

export default Loading;
